import { useDispatch } from 'react-redux'
import { createEducationProfileEvent } from '../actions'

function useCreateEducationProfileEvent() {
  const dispatch = useDispatch()

  return (eventType, eventAt) => {
    dispatch(createEducationProfileEvent(eventType, eventAt))
  }
}

export default useCreateEducationProfileEvent
